var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.21286 0.34375H1.32398L0.119141 3.00934H2.86318L3.21286 0.34375Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.14866 0.34375H3.73785L3.38867 3.00934H6.1202L6.14866 0.34375Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.73807 4.5736C5.77823 4.57009 6.03284 3.87712 6.09566 3.53162H3.375C3.45212 3.8967 3.73121 4.57379 4.73807 4.5736Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7134 3.0094L11.5652 0.343811H9.51172L9.97104 3.0094H12.7134Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.98149 0.34375H6.67053L6.64258 3.00934H9.44165L8.98149 0.34375Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75018 3.53162H0C0.0358858 3.75266 0.123896 4.06946 0.346318 4.29411C0.532577 4.48229 0.7799 4.5736 1.10104 4.5736C2.18307 4.57092 2.59998 3.90816 2.75026 3.53162H2.75018Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19969 4.57093C8.9427 4.62143 9.29898 3.91435 9.43624 3.53162H6.66504C6.77768 4.02006 7.27126 4.5111 8.19969 4.57093Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6384 4.57046C11.9569 4.57046 12.1994 4.47692 12.3806 4.28414C12.5798 4.07297 12.67 3.77981 12.7125 3.53162H10.1113C10.283 3.90778 10.7161 4.57046 11.6384 4.57046H11.6384Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79093 4.03937C9.52598 4.56244 9.0424 5.09593 8.27688 5.09593C8.24007 5.09593 8.20326 5.09483 8.16553 5.09215C7.29816 5.0361 6.71862 4.66658 6.40322 4.20797C6.1449 4.67195 5.64297 5.09262 4.74801 5.09577C3.79908 5.09577 3.28376 4.61857 3.03042 4.11602C2.70182 4.61415 2.0993 5.09354 1.10593 5.09577H1.10547V11.7998C1.10547 11.9437 1.22272 12.0608 1.36665 12.0608H2.50848L2.50857 6.66512C2.50857 6.52062 2.62536 6.4039 2.76975 6.4039H6.47027C6.61447 6.4039 6.73108 6.52061 6.73108 6.66512V12.0613H11.574C11.7179 12.0613 11.8349 11.9444 11.8349 11.8003V5.07615C11.7702 5.08298 11.7082 5.09295 11.6392 5.09295C10.7104 5.09295 10.1174 4.55946 9.79097 4.03953L9.79093 4.03937ZM10.7914 9.27599C10.7914 9.42049 10.6746 9.53721 10.53 9.53721H7.68202C7.53764 9.53721 7.42084 9.42068 7.42084 9.27599L7.42075 6.66524C7.42075 6.52074 7.53736 6.40403 7.68193 6.40403H10.5299C10.6743 6.40403 10.7913 6.52074 10.7913 6.66524L10.7914 9.27599Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.03027 12.0612H6.20934V6.92596H3.03027V12.0612ZM3.17161 9.16726C3.17161 9.02294 3.28821 8.90623 3.43241 8.90623C3.5766 8.90623 3.69359 9.02276 3.69359 9.16726V10.0484C3.69359 10.1929 3.57679 10.3101 3.43241 10.3101C3.28849 10.3101 3.17161 10.1932 3.17161 10.0484V9.16726Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.94336 6.92596H10.2699V9.01501H7.94336V6.92596Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopWhite);
export default __webpack_public_path__ + "static/media/shop-white.ba9c98a75818fca97ccb586431f39343.svg";
export { ForwardRef as ReactComponent };